module.exports = __webpack_public_path__ + "static/media/sBonamici.980593fd.jpeg";